import { render, staticRenderFns } from "./TooltipMeta.vue?vue&type=template&id=506b1f4a&scoped=true&"
import script from "./TooltipMeta.vue?vue&type=script&lang=ts&"
export * from "./TooltipMeta.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipMeta.vue?vue&type=style&index=0&id=506b1f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b1f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
